export default __webpack_public_path__ + "static/media/char_body_003.f78e3973.png";